import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyAYv2QVXUET8xaxz01PqRB4AePvOirHxME",
  authDomain: "amico-m.firebaseapp.com",
  projectId: "amico-m",
  storageBucket: "amico-m.firebasestorage.app",
  messagingSenderId: "47641457187",
  appId: "1:47641457187:web:05d1945f5865686d47b796"
}

export const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)
